module.exports = __webpack_public_path__ + "static/media/mystify_your_mind_100.c2e7641c.ico";